import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { LayoutConfigService } from './config/_core/services/layout-config.service';
import { ClassInitService } from './config/_core/services/class-init.service';


import { TranslationService } from './config/_core/services/translation.service';
import * as objectPath from 'object-path';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationStart, Event as NavigationEvent, NavigationEnd } from '@angular/router';
import { PageConfigService } from './config/_core/services/page-config.service';
import { filter, startWith, switchMap } from 'rxjs/operators';
import { SplashScreenService } from './config/_core/services/splash-screen.service';
import { AclService } from './config/_core/services/acl.service';
import { AuthenticationService } from './content/pages/auth/_core/services/authentication.service';
import { SessionKeys, TokenStorage } from './content/pages/auth/_core/services/token-storage.service';
import { Location } from '@angular/common';

// language list
import { locale as enLang } from './config/i18n/en';
import { locale as chLang } from './config/i18n/ch';
import { locale as esLang } from './config/i18n/es';
import { locale as jpLang } from './config/i18n/jp';
import { locale as deLang } from './config/i18n/de';
import { locale as frLang } from './config/i18n/fr';
import { environment } from '../environments/environment';
import { AuthService } from './content/pages/auth/_core/services/auth.service';
import { PermissionViewActionService } from './shared/services/permission-view-action.service';
import { PermissionNavigationService } from './shared/services/permission-navigation.service';
import { StorageService } from './shared/services/storage.service';
import { StorageKeyEnum } from './shared/enums/storage-key.enum';
import { fromEvent, merge, Observable, Subject, Subscription, timer } from 'rxjs';
import { LangServices } from './content/pages/auth/_core/services/lang.service';
// LIST KNOWN ISSUES
// [Violation] Added non-passive event listener; https://github.com/angular/angular/issues/8866

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'body[m-root]',
	templateUrl: './app.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements AfterViewInit, OnInit,OnDestroy {
	title = 'Metronic';

	@HostBinding('style') style: any;
	@HostBinding('class') classes: any = '';

	@ViewChild('splashScreen', { read: ElementRef })
	splashScreen: ElementRef;
	splashScreenImage: string;
	private intervalRefreshToken = null;
	@Input() action = 'forgot-password';
	currentRoute: String;
	constructor(
		private layoutConfigService: LayoutConfigService,
		private classInitService: ClassInitService,
		private sanitizer: DomSanitizer,
		private translationService: TranslationService,
		private router: Router,
		private pageConfigService: PageConfigService,
		private splashScreenService: SplashScreenService,
		private aclService: AclService,
		private authenticationService: AuthenticationService,
		private tokenStorage: TokenStorage,
		private authService: AuthService,
		private lang_s:LangServices,
		private permissionViewActionService: PermissionViewActionService,
		private permissionNavigationService: PermissionNavigationService,
		private storageService: StorageService,
	) {
		// subscribe to class update event
		this.classInitService.onClassesUpdated$.subscribe(classes => {
			// get body class array, join as string classes and pass to host binding class
			setTimeout(() => this.classes = classes.body.join(' '));
		});

		this.layoutConfigService.onLayoutConfigUpdated$.subscribe(model => {
			this.classInitService.setConfig(model);

			this.style = '';
			if (objectPath.get(model.config, 'self.layout') === 'boxed') {
				const backgroundImage = objectPath.get(model.config, 'self.background');
				if (backgroundImage) {
					this.style = this.sanitizer.bypassSecurityTrustStyle('background-image: url(' + objectPath.get(model.config, 'self.background') + ')');
				}
			}

			// splash screen image
			this.splashScreenImage = objectPath.get(model.config, 'loader.image');
		});

		// register translations
		

		// override config by router change from pages config
		this.lang_s.getLangs().subscribe((response:any) => {
			let dt = [];
			response.forEach(x => {
				let find = dt.find(f=>f.lang==x._lang);
				if(find){
					let index = dt.indexOf(find);
					let _xdata:any = dt[index].data;
					_xdata[x.tipo]=JSON.parse(x.json);
					dt[index].data=_xdata;
				}else{
					let _xdata = {};
					_xdata[x.tipo]=JSON.parse(x.json);
					dt.push({
						lang: x._lang,
						data: _xdata
					});
				}
			});
			//console.log(dt);
			this.translationService.loadTranslations_xarray(dt.length>0?dt:[esLang]);

			this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				if(this.permissionNavigationService.get() != null) {
					this.permissionNavigationService.loadViewAction(event.url);
				}
				this.layoutConfigService.setModel({ page: objectPath.get(this.pageConfigService.getCurrentPageConfig(), 'config') }, true);
			});
		}, (error) => {});
	}

	ngOnInit(): void {
		const url = this.router.url;
		//getLangs
		
		this.router.events
			.subscribe(
				(event: NavigationEvent) => {
				if(event instanceof NavigationEnd) {
					this.currentRoute =event.url;
				}
				});
		console.log("viendo el retorno")
		this.intervalRefreshToken = setInterval(() => {
			let array_current =  this.currentRoute.split("?");
			if (this.authService.isLoggedIn()) 
			{
				this.authService.refreshToken().subscribe(() => { });
				if(this.storageService.get(StorageKeyEnum.Type)=='S'){
					this.authService.redirectToChangePw() 
				}
			}else if(this.currentRoute == '/forgot-password') {
				this.action = 'forgot-password'
			}
			else if(array_current[0] == '/RecoveryPass') {
				this.action = 'recovery-pass'	
			}else if(array_current[0] == '/login2FA') {
				this.action = 'login2-factor'
			}
			else {
				this.authService.logoff();
				this.authService.redirectToLogin();
			}
		}, environment.timeToRefreshToken)
		this.initializeIdle();
	}

	ngAfterViewInit(): void {
		if (this.splashScreen) {
			this.splashScreenService.init(this.splashScreen.nativeElement);
		}
	}

	ngOnDestroy(): void {
		if (this.intervalRefreshToken != null) {
			this.intervalRefreshToken.clearInterval();
		}
		this.refreshTimer();
	}

	//#region  idle
	destroy = new Subject();
	showDialog = false;
	timer: number;
	showNotice = false;
	rxjsTimer = timer(1000, 1000);
	reset$ = new Subject();
	sub: Observable<number>;
	val: number;
	private idle: Observable<any> = new Observable();
	private idleSubscription: Subscription = new Subscription();
	initializeIdle=()=>{
		this.authService.GetSleepIdleMinutes()
		.subscribe(response => {
			let minutes = Number(response);
			if(minutes>0){
				this.initializeTimer(minutes * 60);
				this.sub.subscribe(val => (this.val = val));
			}
		}, (error) => {});
	}
	initializeTimer(timeOutSeconds:number): void {
		let timeOutMilliSeconds = timeOutSeconds * 1000;
		this.idle = merge(
			fromEvent(document, 'mousemove'),
			fromEvent(document, 'click'),
			fromEvent(document, 'mousedown'),
			fromEvent(document, 'keypress'), 
			fromEvent(document, 'DOMMouseScroll'),
			fromEvent(document, 'mousewheel'),
			fromEvent(document, 'touchmove'),
			fromEvent(document, 'MSPointerMove')
		  );
		this.idleSubscription = this.idle.subscribe((res) => {
			this.refreshTimer();
		});
		this.sub = this.reset$.pipe(
		  startWith(void 0),
		  switchMap(() => timer(timeOutMilliSeconds, timeOutMilliSeconds))
		);
		let $this = this;
		this.sub.subscribe((res) => {
			let array_current = $this.currentRoute.split("?");
			if( array_current[0] == '/forgot-password' ||
				array_current[0] == '/RecoveryPass' ||
				array_current[0] == '/login2FA' ||
				array_current[0] == '/login'){
				$this.refreshTimer();
			}else{
				$this.authService.logoff();
				$this.authService.redirectToLogin();
				alert("Se agotó el tiempo de espera, usted será redirigido a la pagina de inicio.");
				$this.refreshTimer();
			}		
		});
	}
	refreshTimer(): void {
		this.reset$.next(void 0);
	}
	//#endregion
}
